.teaser-cluster {
  width: 100%;
  margin-bottom: 16px;
}

.teaser-cluster__container {
  display: flex;
  flex-direction: column;

  ::slotted(scs-teaser) {
    width: 100%;
    height: 100%;
  }
}

.teaser-cluster {
  width: 100%;
  height: 100%;
}

.teaser-cluster__container {
  gap: 24px;
}

@media (min-width: 768px) {
  .teaser-cluster__container {
    display: grid;
    flex-direction: unset;

    ::slotted(scs-teaser) {
      width: 100%;
      height: 100%;
    }
  }

  // Grid layout based on teaserNumber
  .teaser-cluster[data-teaser-number="2"] .teaser-cluster__container {
    grid-template-columns: 5fr 5fr;
    grid-template-rows: 1fr;
  }

  // 2 teasers with "left" layout: 70% left, 30% right
  .teaser-cluster[data-teaser-number="2"][data-layout="left"]
    .teaser-cluster__container {
    grid-template-columns: 7fr 3fr;
    grid-template-rows: 1fr;
  }

  // 2 teasers with "right" layout: 30% left, 70% right
  .teaser-cluster[data-teaser-number="2"][data-layout="right"]
    .teaser-cluster__container {
    grid-template-columns: 3fr 7fr;
    grid-template-rows: 1fr;
  }

  .teaser-cluster[data-teaser-number="4"] .teaser-cluster__container {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }

  .teaser-cluster[data-teaser-number="4"][data-layout="half"]
    .teaser-cluster__container {
    display: flex;

    .teaser-cluster__column {
      width: 100%;
      display: flex;
      flex-direction: column;
    }

    // Column 1: teaser-1 (488px)
    [name="teaser-1"] {
      display: block;
      height: 488px;
    }

    // Column 1: teaser-3 (432px)
    [name="teaser-3"] {
      display: block;
      height: 432px;
    }

    // Column 2: teaser-2 (432px)
    [name="teaser-2"] {
      display: block;
      height: 432px;
    }

    // Column 2: teaser-4 (488px)
    [name="teaser-4"] {
      display: block;
      height: 488px;
    }
  }

  // 4 teasers with "left" layout: Row 1 (70%/30%), Row 2 (60%/40%)
  .teaser-cluster[data-teaser-number="4"][data-layout="left"]
    .teaser-cluster__container {
    display: flex;
    flex-wrap: wrap;

    ::slotted(scs-teaser) {
      width: auto;
      height: auto;
    }

    // First row: 70% / 30%
    ::slotted(scs-teaser:nth-child(1)) {
      flex: 0 0 calc(70% - 12px);
    }

    ::slotted(scs-teaser:nth-child(2)) {
      flex: 0 0 calc(30% - 12px);
    }

    // Second row: 60% / 40%
    ::slotted(scs-teaser:nth-child(3)) {
      flex: 0 0 calc(60% - 12px);
    }

    ::slotted(scs-teaser:nth-child(4)) {
      flex: 0 0 calc(40% - 12px);
    }
  }

  // 4 teasers with "right" layout: Row 1 (30%/70%), Row 2 (40%/60%)
  .teaser-cluster[data-teaser-number="4"][data-layout="right"]
    .teaser-cluster__container {
    display: flex;
    flex-wrap: wrap;

    ::slotted(scs-teaser) {
      width: auto;
      height: auto;
    }

    // First row: 30% / 70%
    ::slotted(scs-teaser:nth-child(1)) {
      flex: 0 0 calc(30% - 12px);
    }

    ::slotted(scs-teaser:nth-child(2)) {
      flex: 0 0 calc(70% - 12px);
    }

    // Second row: 40% / 60%
    ::slotted(scs-teaser:nth-child(3)) {
      flex: 0 0 calc(40% - 12px);
    }

    ::slotted(scs-teaser:nth-child(4)) {
      flex: 0 0 calc(60% - 12px);
    }
  }
}
